import { z } from 'zod';
import { fileInputSchema } from '../../shared';
export const dataUploadSchema = z
    .object({
    value_date: z.string(),
    liquidity_report: fileInputSchema.optional(),
    rating: fileInputSchema.optional(),
})
    .refine((data) => data.liquidity_report !== undefined || data.rating !== undefined, 'Upload at least one liquidity report or rating file.');
